import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard = (...allowedRoles: string[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isLoggedIn) {
      router.navigate(['/login']);
      return false;
    }

    if (authService.currentUser && allowedRoles.includes(authService.currentUser.role!)) {
      return true;
    }

    const homeByRole: Record<string, string> = {
      admin: '/admin',
      master: '/master',
      member: '/member',
      support: '/support',
      shop: '/shop',
    };
    const fallback = homeByRole[authService.currentUser?.role || ''] || '/login';
    router.navigate([fallback]);
    return false;
  };
};
